import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAYm8WyRRkNJ5yf4nl-lIp2AFHvT-ON4Ug",
  authDomain: "wedding-card-maker-android.firebaseapp.com",
  databaseURL: "https://wedding-card-maker-android.firebaseio.com",
  projectId: "wedding-card-maker-android",
  storageBucket: "wedding-card-maker-android.appspot.com",
  messagingSenderId: "681611841715",
  appId: "1:681611841715:web:134e13302f3f7cfbdda0c6",
  measurementId: "G-H7PJ2YQHLV"
};

export default {
  beforeCreate(_, inject) {
    let firebaseApp = null;
    try {
      firebaseApp = firebase.app();
    } catch (e) {
      if (e.code === "app/no-app")
        firebaseApp = firebase.initializeApp(firebaseConfig);
      else console.error(e);
    }

    /** Initialized Firebase App instance */
    inject("fire", firebaseApp);

    /** For accessing Firebase modules like firebase.auth */
    inject("fireModule", firebase);
  }
};
